var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-select',{attrs:{"value":_setup.props.value ?? '',"options":_setup.state.accounts,"placeholder":_vm.placeholder,"disabled":_setup.props.disabled ?? false},on:{"change":_setup.changed}},[_vm._t("default",function(){return [_vm._v(_vm._s(_setup.props.label ?? ''))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }